import styled from "styled-components";

export const UserStatusStandardLotInfoDescriptionStyled = styled.div`
    color: var(--color-label-secondary);
    font-size: 14px;
    
    p:last-child {
        margin-bottom: 0;
    }
`;
